import { useEffect, useMemo, useState } from "react";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { CourseCard } from "@/components/site/CourseCard";
import { FullLoader } from "@/components/site/Layout";

export default function Courses() {
  useSeo("الكورسات", "تصفح كل كورسات أكاديمية خرابيش في الموشن جرافيك والأنيميشن.");
  const [courses, setCourses] = useState(null);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("الكل");
  useEffect(() => { api.get("/courses").then((r) => setCourses(r.data)).catch(() => setCourses([])); }, []);
  const cats = useMemo(() => ["الكل", ...new Set((courses || []).map((c) => c.category).filter(Boolean))], [courses]);
  const list = (courses || []).filter((c) => (cat === "الكل" || c.category === cat) && c.title.includes(q.trim()));

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16" data-testid="courses-page">
      <header className="mb-12 space-y-4">
        <h1 className="font-display text-5xl sm:text-6xl text-ink">كل الكورسات</h1>
        <p className="text-soft max-w-xl">اختار المهارة اللي عايز تتعلمها وابدأ دلوقتي.</p>
      </header>
      <div className="flex flex-col md:flex-row gap-4 md:items-center justify-between mb-10">
        <div className="flex flex-wrap gap-2">
          {cats.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`courses-filter-${c}`}
              className={`px-4 py-2 rounded-full text-sm border-2 transition-colors ${cat === c ? "bg-[#FFFFFF] text-[var(--kh-violet)] border-[var(--kh-deep)] font-semibold" : "border-line text-soft hover:border-[var(--kh-violet)]"}`}>{c}</button>
          ))}
        </div>
        <label className="relative">
          <Search className="absolute right-3 top-1/2 -translate-y-1/2 text-soft" size={18} />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="دوّر على كورس..." data-testid="courses-search-input"
            className="kh-input md:w-72 !rounded-full !py-2.5 !pr-10 text-sm" />
        </label>
      </div>
      {courses === null ? <FullLoader /> : list.length === 0 ? (
        <p className="text-center text-soft py-20" data-testid="courses-empty">مفيش كورسات متاحة حالياً — تابعنا قريب.</p>
      ) : (
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {list.map((c, i) => <CourseCard key={c.id} course={c} index={i} />)}
        </div>
      )}
    </div>
  );
}
